import { gql } from "@apollo/client";

export const GET_LEADERBOARD_FOR_ADMIN = gql`
  query getLeaderboardForAdmin($pagination: PaginationInputType!, $regionCountry: String, $regionCity: String, $username: String, $level: String, $orderBy: UserOrderByWithRelationInput) {
    getLeaderboardForAdmin(pagination: $pagination, regionCountry: $regionCountry, regionCity: $regionCity, username: $username, level: $level, orderBy: $orderBy) {
      leaderboard {
        id
        username
        firstName
        lastName
        email
        numberOfRecommendations
        totalPoints
        profilePictureUrl
        rank
        level
        levelInfo {
          longestStreak
          referredUsers
          referredUsersWhoRecommended
          joinedATeam
          commentedInATeam
        }
      }
      total
    }
  }
`;

export const GET_LEADERBOARD_FOR_CITIES = gql`
  query getLeaderboardForCities($pagination: PaginationInputType!, $regionCountry: String) {
    getLeaderboardForCities(pagination: $pagination, regionCountry: $regionCountry) {
      cities {
        rank
        regionCity
        sum
      }
      total
    }
  }
`;

export const GET_APP_CONFIG = gql`
  query fetchAppConfig {
    fetchAppConfig {
      id
      key
      value
    }
  }
`;

export const GET_USER_LEADERBOARD = gql`
  query getUserLeaderboard($username: String!) {
    getUserLeaderboard(username: $username) {
      firstTen {
        id
        rank
        username
        totalPoints
        profilePictureUrl
        levelInfo {
          longestStreak
          referredUsers
          referredUsersWhoRecommended
          joinedATeam
          commentedInATeam
        }
      }
      aroundMe {
        id
        username
        rank
        totalPoints
        profilePictureUrl
        levelInfo {
          longestStreak
          referredUsers
          referredUsersWhoRecommended
          joinedATeam
          commentedInATeam
        }
      }
    }
  }
`;